import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { hydrate } from "@/lib";
import type { ResponsePayload } from "@/types";
import { fetchBackgroundColours } from "./thunk";

export interface ToolCustomizationsState {
  backgroundColours: Array<{ name: string; id: number }>;
  status: "idle" | "fetching" | "saving";
  error: null | string;
}

const initialState: ToolCustomizationsState = {
  backgroundColours: [],
  status: "idle",
  error: null
};

export const toolCustomizationsSlice = createSlice({
  name: "toolCustomizations",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(hydrate, (state, action: PayloadAction<string>) => {
        return {
          ...state,
          ...action.payload[toolCustomizationsSlice.name]
        };
      })
      .addCase(fetchBackgroundColours.pending, (state) => {
        state.status = "fetching";
      })
      .addCase(fetchBackgroundColours.fulfilled, (state, action) => {
        state.status = "idle";
        state.backgroundColours = action.payload.length
          ? action.payload.filter(({ name }) => name !== "#E2E8F0")
          : [];
      })
      .addCase(fetchBackgroundColours.rejected, (state, action) => {
        const { statusText } = action.payload as ResponsePayload;

        state.status = "idle";
        state.error = statusText;
      });
  }
});
